import { IsBoolean, IsOptional, IsString, IsUUID, IsIn, ValidateIf } from 'class-validator';

export class CreateShippingProcessConfigRequestDto {
    /**
     * Warehouse detail ID - link to warehouse
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @IsOptional()
    @ValidateIf((o) => o.warehouseDetailId !== '' && o.warehouseDetailId != null)
    @IsUUID()
    warehouseDetailId?: string;

    /**
     * Product ID - link to product this config applies to
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @IsOptional()
    @ValidateIf((o) => o.productId !== '' && o.productId != null)
    @IsUUID()
    productId?: string;

    /**
     * Shipping direction (Inbound or Outbound)
     * @example 'Inbound'
     */
    @IsOptional()
    @IsString()
    direction?: string;

    /**
     * Is controlled temperature shipping used?
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    controlledTempShippingUsed?: boolean;

    /**
     * Type of container/vehicle (e.g. Topa Thermal, CSafe RKN, Credo Cubes)
     * @example 'Topa Thermal containers, CSafe RKN units'
     */
    @IsOptional()
    @IsString()
    containerOrVehicleType?: string;

    /**
     * Are temperature data loggers used?
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    tempDataLoggersUsed?: boolean;

    /**
     * Type of logger (e.g. LIBERO CB, Sensitech)
     * @example 'LIBERO CB'
     */
    @IsOptional()
    @IsString()
    loggerType?: string;

    /**
     * Logger location (Internal, External for inbound)
     * @example 'Internal'
     */
    @IsOptional()
    @ValidateIf((o) => o.loggerLocation !== '' && o.loggerLocation != null)
    @IsString()
    @IsIn(['Internal', 'External'])
    loggerLocation?: string;

    /**
     * Is heated service required?
     * @example false
     */
    @IsOptional()
    @IsBoolean()
    heatedServiceRequired?: boolean;

    /**
     * Date range for heated service
     * @example 'December-February'
     */
    @IsOptional()
    @IsString()
    heatedServiceDateRange?: string;

    /**
     * Protect from freezing required (for Outbound)
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    protectFromFreezingRequired?: boolean;

    /**
     * Transportation provider name (e.g., DHL Global Forwarding, FedEx Custom Critical, ATS)
     * @example 'DHL Global Forwarding'
     */
    @IsOptional()
    @IsString()
    transportationProviderName?: string;

    /**
     * Client Logistics Contact ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @IsOptional()
    @ValidateIf((o) => o.logisticsContactId !== '' && o.logisticsContactId != null)
    @IsUUID()
    logisticsContactId?: string;

    /**
     * Notes
     * @example 'Jazz logistics managed through Lynden'
     */
    @IsOptional()
    @IsString()
    notes?: string;
}
